import { render, staticRenderFns } from "./MyPushuPreview.vue?vue&type=template&id=efc2aa34&"
import script from "./MyPushuPreview.vue?vue&type=script&lang=js&"
export * from "./MyPushuPreview.vue?vue&type=script&lang=js&"
import style0 from "./MyPushuPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports